/**
 * Snippets API
 * Here is the API DNA
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { RuleOfFolder } from '../model/ruleOfFolder';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable()
export class RulesoffolderService {
  protected basePath = 'http://localhost:9000/api';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration,
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

  /**
   *
   * View with a single GET method that returns the rules of a specific folder, their status, variables and/or constants and associated predictions in a single json structure. Might be better to not use a ModelSet for this.
   * @param folder The folder of which to fetch the rules and their status.
   * @param mode The mode for which to fetch the rules.
   * @param root_rule The root rule for which to fetch the branches.
   * @param leaf_child The leaf child id of the branch to fetch.
   * @param rule_type The type of rules to fetch.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public rulesoffolderList(
    folder: string,
    mode?: string,
    root_rule?: number,
    leaf_child?: string,
    rule_type?: string,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<Array<RuleOfFolder>>;
  public rulesoffolderList(
    folder: string,
    mode?: string,
    root_rule?: number,
    leaf_child?: string,
    rule_type?: string,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<Array<RuleOfFolder>>>;
  public rulesoffolderList(
    folder: string,
    mode?: string,
    root_rule?: number,
    leaf_child?: string,
    rule_type?: string,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<Array<RuleOfFolder>>>;
  public rulesoffolderList(
    folder: string,
    mode?: string,
    root_rule?: number,
    leaf_child?: string,
    rule_type?: string,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    if (folder === null || folder === undefined) {
      throw new Error('Required parameter folder was null or undefined when calling rulesoffolderList.');
    }

    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    if (folder !== undefined && folder !== null) {
      queryParameters = queryParameters.set('folder', <any>folder);
    }
    if (mode !== undefined && mode !== null) {
      queryParameters = queryParameters.set('mode', <any>mode);
    }
    if (root_rule !== undefined && root_rule !== null) {
      queryParameters = queryParameters.set('root_rule', <any>root_rule);
    }
    if (leaf_child !== undefined && leaf_child !== null) {
      queryParameters = queryParameters.set('leaf_child', <any>leaf_child);
    }
    if (rule_type !== undefined && rule_type !== null) {
      queryParameters = queryParameters.set('rule_type', <any>rule_type);
    }

    let headers = this.defaultHeaders;

    // authentication (Basic) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set(
        'Authorization',
        'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
      );
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Array<RuleOfFolder>>('get', `${this.basePath}/rulesoffolder/`, {
      params: queryParameters,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   *
   * View with a single GET method that returns the rules of a specific folder, their status, variables and/or constants and associated predictions in a single json structure. Might be better to not use a ModelSet for this.
   * @param id
   * @param folder The folder of which to fetch the rules and their status.
   * @param mode The mode for which to fetch the rule.
   * @param leaf_child The leaf child id of the branch to fetch.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public rulesoffolderRead(
    id: string,
    folder: string,
    mode?: string,
    leaf_child?: string,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<RuleOfFolder>;
  public rulesoffolderRead(
    id: string,
    folder: string,
    mode?: string,
    leaf_child?: string,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<RuleOfFolder>>;
  public rulesoffolderRead(
    id: string,
    folder: string,
    mode?: string,
    leaf_child?: string,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<RuleOfFolder>>;
  public rulesoffolderRead(
    id: string,
    folder: string,
    mode?: string,
    leaf_child?: string,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling rulesoffolderRead.');
    }

    if (folder === null || folder === undefined) {
      throw new Error('Required parameter folder was null or undefined when calling rulesoffolderRead.');
    }

    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    if (folder !== undefined && folder !== null) {
      queryParameters = queryParameters.set('folder', <any>folder);
    }
    if (mode !== undefined && mode !== null) {
      queryParameters = queryParameters.set('mode', <any>mode);
    }
    if (leaf_child !== undefined && leaf_child !== null) {
      queryParameters = queryParameters.set('leaf_child', <any>leaf_child);
    }

    let headers = this.defaultHeaders;

    // authentication (Basic) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set(
        'Authorization',
        'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
      );
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<RuleOfFolder>(
      'get',
      `${this.basePath}/rulesoffolder/${encodeURIComponent(String(id))}/`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   *
   * Return the snapshot of the rules (for frozen folder modes).
   * @param folder The folder of which to fetch the rules and their status.
   * @param frozen_mode The frozen mode for which to fetch snapshot.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public rulesoffolderSnapshot(
    folder: string,
    frozen_mode: string,
    observe?: 'body',
    reportProgress?: boolean,
  ): Observable<Array<RuleOfFolder>>;
  public rulesoffolderSnapshot(
    folder: string,
    frozen_mode: string,
    observe?: 'response',
    reportProgress?: boolean,
  ): Observable<HttpResponse<Array<RuleOfFolder>>>;
  public rulesoffolderSnapshot(
    folder: string,
    frozen_mode: string,
    observe?: 'events',
    reportProgress?: boolean,
  ): Observable<HttpEvent<Array<RuleOfFolder>>>;
  public rulesoffolderSnapshot(
    folder: string,
    frozen_mode: string,
    observe: any = 'body',
    reportProgress: boolean = false,
  ): Observable<any> {
    if (folder === null || folder === undefined) {
      throw new Error('Required parameter folder was null or undefined when calling rulesoffolderSnapshot.');
    }

    if (frozen_mode === null || frozen_mode === undefined) {
      throw new Error('Required parameter frozen_mode was null or undefined when calling rulesoffolderSnapshot.');
    }

    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    if (folder !== undefined && folder !== null) {
      queryParameters = queryParameters.set('folder', <any>folder);
    }
    if (frozen_mode !== undefined && frozen_mode !== null) {
      queryParameters = queryParameters.set('frozen_mode', <any>frozen_mode);
    }

    let headers = this.defaultHeaders;

    // authentication (Basic) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set(
        'Authorization',
        'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password),
      );
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Array<RuleOfFolder>>('get', `${this.basePath}/rulesoffolder/snapshot/`, {
      params: queryParameters,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }
}
